import { getImagePath } from '@bikemap/js/utility'

/**
 * Get the object of all image variants to pass as prop to the base promotion modal.
 * @param {string} path Relative path inside img/promotions without file ending
 * @returns {import("./BasePromotionModal").ImgVersions}
 */
export function getImageVariants(path) {
    return {
        jpg: getImagePath('promotions/' + path + '.jpg'),
        webp: getImagePath('promotions/' + path + '.webp'),
        avif: getImagePath('promotions/' + path + '.avif'),
    }
}
